<script lang="ts">
	const { accountId }: { accountId?: string } = $props();
</script>

<svelte:head>
	{#if accountId}
		{@html `
    <script type="text/javascript" src="//static.criteo.net/js/ld/ld.js" async></script>
  `}
	{/if}
</svelte:head>
